import React from "react";
import PropTypes from "prop-types";
import { Divider } from "@qgiv/core-donor";
import ConnectedParticipantCounter from "./ConnectedParticipantCounter";
import ConnectedParticipantSummary from "./ConnectedParticipantSummary";

const ParticipantList = ({
    displayDivider,
    displayParticipantCounter,
    registrations = [],
    isCms,
    renderRegistrations = () => {},
}) => (
    <>
        {displayParticipantCounter && <ConnectedParticipantCounter />}
        {displayDivider && (
            <Divider classNames="registration-summary__divider" dark={false} />
        )}
        {/* eslint-disable-next-line tailwindcss/classnames-order */}
        <div className="grid grid--no-gutters">
            {isCms
                ? renderRegistrations(registrations)
                : registrations.map((_registration, i) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <div className="col col--12" key={i}>
                          <ConnectedParticipantSummary registrationIndex={i} />
                      </div>
                  ))}
        </div>
    </>
);
ParticipantList.propTypes = {
    // Flag telling us to display the divider above the list of participants
    displayDivider: PropTypes.bool.isRequired,
    // Flag telling us to display the participant counter UI
    displayParticipantCounter: PropTypes.bool.isRequired,
    // Array of registration objects to map over
    registrations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    // Flag of if loading in cms
    isCms: PropTypes.bool.isRequired,
    // Render ConnectedParticipantSummary from ThemeControls
    renderRegistrations: PropTypes.func,
};

export default ParticipantList;
